const typography = {
  fontFamily: [
    'Open Sans',
  ].join(','),
  fontSize: 16,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 600,
  h1: {
    fontSize: '1.5rem',
    fontWeight: 600,
    lineHeight: 1.25,
  },
  h2: {
    fontSize: '1.25rem',
    fontWeight: 600,
    lineHeight: 1.25,
  },
  h3: {
    fontSize: '1rem',
    fontWeight: 600,
    lineHeight: 1.25,
  },
  h4: {
    fontSize: '0.875rem',
    fontWeight: 600,
    lineHeight: 1.25,
  },
  h5: {
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: 1.25,
  },
  h6: {
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: 1.25,
  },
  body1: {
    fontSize: '0.875rem',
    lineHeight: 1.25,
  },
  body2: {
    fontSize: '0.875rem',
    lineHeight: 1.5,
  },
  button: {
    textTransform: 'none',
  },
}

export default typography
